import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FrameModule } from '@app-frame';
import { ConverterModule, UnitConverterModule } from '@converter';
import { CxFormsModule } from '@forms';
import { UiFormatModule } from '@ui-format';
import { BenchmarkDashboardComponent } from './benchmark-dashboard.component';

import { BenchmarkFavouritesWindow } from './windows/favourites/benchmark-favourites.component';
import { DashboardEditorModul } from '@dashboards-editor';
import { DatapointRowComponent } from './windows/datapoint-selector/datapoint-row.component';
import { DatapointSelectorComponent } from './windows/datapoint-selector/datapoint-selector.component';
import { BenchmarkDashboardStorageService } from './benchmark-dashboard.storage.service';
import { BenchmarkDashboardDataService } from './benchmark-dashboard.data.service';
import { EngeryBarChartComponent } from './charts/benchmark.barchart.component';
import { DxChartModule } from 'devextreme-angular';
import { AxisHelperService } from './axis-helper.service';
import { BenchmarkPropertyWindow } from './windows/dashboard-properties/dashboard-properties.component';
import { UiTabsModule } from '@ui-tabs';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CxFormsModule,
        UiFormatModule,
        DxChartModule,
        ConverterModule,
        UnitConverterModule,
        FrameModule,
        DashboardEditorModul,
        UiTabsModule
    ],
    declarations: [
        BenchmarkDashboardComponent,
        BenchmarkFavouritesWindow,
        DatapointRowComponent,
        DatapointSelectorComponent,
        EngeryBarChartComponent,
        BenchmarkPropertyWindow
    ],
    exports: [
        BenchmarkDashboardComponent,
        BenchmarkFavouritesWindow,
        BenchmarkPropertyWindow
    ],
    providers: [
        BenchmarkDashboardStorageService,
        BenchmarkDashboardDataService,
        AxisHelperService
    ],
    schemas : [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class BenchmarkDashboardModule {

}

export {
    BenchmarkDashboardComponent,
    BenchmarkPropertyWindow
};
